import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function addCart({ client, config }: Context, parms: CustomQuery): Promise<ApiResult> {
  const { sku_id, num, good_id } = parms;
  const url = new URL('/mall/cart/add', config.api.url);

  // // Add parameters passed from composable as query strings to the URL
  // url.searchParams.set('password', password);
  const query: CustomQuery = {
    sku_id: sku_id,
    num: num,
    good_id: good_id
  };

  // Use axios to send a GET request
  const result = await client.post(url.href, query);
  // console.log('res', result.data);
  // Return data from the API
  return result.data;
}
